<template>
  <div class="settings page--settings">
        <div class="page__header">
          <div class="page__title">
            <div class="page__title-icon">
              <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="27" height="27" rx="8" fill="#64748B"/>
                <path
                    d="M19.8621 12.4076L18.2816 12.2437C18.1726 11.8613 18.0091 11.479 17.8456 11.1513L18.8266 9.89496C18.9356 9.78571 18.8811 9.62185 18.8266 9.51261L17.6276 8.31092C17.5186 8.20168 17.3551 8.20168 17.2461 8.31092L15.9926 9.29412C15.6656 9.07563 15.2841 8.96639 14.9026 8.85714L14.7391 7.27311C14.6301 7.10924 14.5211 7 14.4121 7H12.7226C12.5591 7 12.4501 7.10924 12.4501 7.21849L12.2866 8.80252C11.905 8.91176 11.5235 9.07563 11.1965 9.2395L9.88853 8.31092C9.77953 8.20168 9.61602 8.2563 9.50702 8.31092L8.30801 9.51261C8.19901 9.62185 8.19901 9.78571 8.30801 9.89496L9.28902 11.1513C9.07102 11.479 8.96202 11.8613 8.85302 12.2437L7.2725 12.4076C7.109 12.4622 7 12.5714 7 12.6807V14.374C7 14.5378 7.109 14.6471 7.218 14.6471L8.79852 14.8109C8.90752 15.1933 9.07102 15.5756 9.23452 15.9034L8.25351 17.1597C8.14451 17.2689 8.19901 17.4328 8.25351 17.542L9.45252 18.7437C9.56152 18.8529 9.72503 18.8529 9.83403 18.7437L11.0875 17.7605C11.4145 17.979 11.796 18.0882 12.1775 18.1975L12.3411 19.7815C12.3411 19.9454 12.4501 20 12.6136 20H14.3031C14.4666 20 14.5756 19.8908 14.5756 19.7815L14.7391 18.1975C15.1206 18.0882 15.5021 17.9244 15.8291 17.7605L17.0826 18.7437C17.1916 18.8529 17.3551 18.7983 17.4641 18.7437L18.6631 17.542C18.7721 17.4328 18.7721 17.2689 18.6631 17.1597L17.6821 15.9034C17.9001 15.5756 18.0091 15.1933 18.1181 14.8109L19.6986 14.6471C19.8621 14.6471 19.9166 14.5378 19.9166 14.374V12.6807C20.0801 12.5714 19.9711 12.4622 19.8621 12.4076ZM13.5401 15.7395C12.3411 15.7395 11.36 14.7563 11.36 13.5546C11.36 12.3529 12.3411 11.3697 13.5401 11.3697C14.7391 11.3697 15.7201 12.3529 15.7201 13.5546C15.7201 14.7563 14.7391 15.7395 13.5401 15.7395Z"
                    fill="white"/>
              </svg>

            </div>
            <div class="page__title-text">
              {{ $t("settings.page.title") }}
            </div>
          </div>
        </div>
        <div class="settings__content">
          <div class="settings__tabs">
            <router-link
                :to="{name: page.route, params: {id: selectedCompany}}"
                class="settings__tabs-item"
                v-for="page in $options.SETTINGS_PAGES"
                active-class="active"
                :key="`page-${page.route}`"
            >
              {{ $t(page.title) }}
            </router-link>
          </div>
          <div class="settings__content-page">
            <router-view></router-view>
          </div>
        </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SettingsBase',
  SETTINGS_PAGES: [
    {
      title: 'settings.pages.users',
      route: 'settings-users',
    },
  ],
  computed: {
    ...mapState(['selectedCompany']),
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--settings {
    margin-top: 30px;
  }
}
.settings {
  &__tabs {
    margin-bottom: 19px;

    margin-top: 35px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eff2f8;
    display: flex;
    align-items: center;

    &-item {
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #67768a;
      opacity: 0.7;

      position: relative;
      padding: 0 10px;
      margin-right: 14px;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        opacity: 0.6;
      }

      &:last-child {
        margin-right: 0;
      }

      &.active {
        font-weight: 600;
        font-size: 16px;
        line-height: 28px;
        color: #465a8b;
        opacity: 1;

        &:after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          bottom: -15px;
          background: #64748B;
          border-radius: 8px;
          width: 100%;
          height: 5px;
        }
      }
    }
  }

  &__content {
    margin-top: 35px;

    &-page {
    }
  }
}
</style>
